import { render, staticRenderFns } from "./ErrorState.vue?vue&type=template&id=bf04bc3e&scoped=true&"
import script from "./ErrorState.vue?vue&type=script&lang=js&"
export * from "./ErrorState.vue?vue&type=script&lang=js&"
import style0 from "./ErrorState.vue?vue&type=style&index=0&id=bf04bc3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf04bc3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf04bc3e')) {
      api.createRecord('bf04bc3e', component.options)
    } else {
      api.reload('bf04bc3e', component.options)
    }
    module.hot.accept("./ErrorState.vue?vue&type=template&id=bf04bc3e&scoped=true&", function () {
      api.rerender('bf04bc3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/ErrorState.vue"
export default component.exports